import { MixDesignConstituent } from '../constants/MixDesignConstituent';
import MaterialStore from '../stores/material-store';

// This function is used to expand the unit symbol of a mix design constituent to a more descriptive form
// For example, 'oz' will be expanded to 'oz/cwt' for cement-based constituents or 'oz/yd' for volume-based constituents
// This is purely for display purposes, and does not affect the underlying data
export const getExpandedConstituentUnit = (constituent: MixDesignConstituent, materialStore: MaterialStore) => {
  const materialDetails = materialStore.getConstituentMaterialDetails(constituent);

  const lowercaseUnitSymbol = constituent.unitSymbol && constituent.unitSymbol.toLowerCase();

  switch (lowercaseUnitSymbol) {
    case 'oz':
    case 'lb':
    case 'ga':
      // US Customary units
      // Expand to per hundredweight for cement-based or per cubic yard for volume-based
      return materialDetails?.byCement ? `${lowercaseUnitSymbol}/cwt` : `${lowercaseUnitSymbol}/yd`;
    case 'kg':
    case 'ml':
    case 'l':
      // Metric units
      return materialDetails?.byCement ? `${lowercaseUnitSymbol}/cwt` : `${lowercaseUnitSymbol}/m3`;
    default:
      return constituent.unitSymbol;
  }
};
